import React, { useState, useEffect, Fragment } from "react";
import apiRequest from "../../Api";
import BasicTable from "../../components/VirtuosoTable";
import ReactToast from "../../components/Toast";
import SearchBar from "../../components/SearchBar";

function LedgerListing(props) {
  const [ledgerList, setLedgerList] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [headerInfo, setHeaderInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isLoading) {
      CallAPiList();
    }
  }, [isLoading]); // Updated dependency array to contain isLoading only

  const onSearch = (event) => {
    let searchterm = event.target.value;

    if (searchterm) {
      const newItems = ledgerList.filter((row, index) => {
        return (
          row.date.toLowerCase().includes(searchterm.toLowerCase()) ||
          row.acname.toLowerCase().includes(searchterm.toLowerCase()) ||
          row.remarks.toLowerCase().includes(searchterm.toLowerCase()) ||
          row.debit.toLowerCase().includes(searchterm.toLowerCase()) ||
          row.credit.toLowerCase().includes(searchterm.toLowerCase()) ||
          row.balance.toLowerCase().includes(searchterm.toLowerCase()) ||
          row.dc.toLowerCase().includes(searchterm.toLowerCase())
        );
      });
      setFilterData(newItems);
    } else {
      setFilterData(ledgerList);
    }
  };

  let headerData = [
    {
      label: "Date",
      render: (data) => data.date,
      width: "100px",
      className: "text-left",
    },
    /*{
      label: "Account",
      render: (data) => data.acname,
      className: "text-left",
    },
    {
      label: "Desc",
      render: (data) => data.remarks,
      className: "text-left",
    },
    */
    {
      label: "Debit(₹)",
      render: (data) => data.debit,
      className: "text-right",
    },
    {
      label: "Credit(₹)",
      render: (data) => data.credit,
      className: "text-right",
    }
    /*,
    {
      label: "Balance",
      render: (data) => data.balance,
      className: "text-right",
    },
    {
      label: "DC",
      render: (data) => data.dc,
      className: "text-right",
    },
    */
    // {
    //   label: "Chq/Ref. No",
    //   render: (data) => data.vCheque,
    //   className: "text-right",
    // },
    // {
    //   label: "Chq/Ref. Dt.",
    //   render: (data) => data.date,
    //   className: "text-right",
    // },
    // {
    //   label: "Recon. Dt.",
    //   render: (data) => data.date,
    //   className: "text-right",
    // },
    // {
    //   label: "Recon. Status",
    //   render: (data) => data.ePaymentStatus,
    //   className: "text-right",
    // },
  ];

  const CallAPiList = async () => {
    try {
      const url = process.env.REACT_APP_API_BASE;

      let apiSetting = {
        method: "POST",
        // Include your API parameters here
        apiParams: {
          partypkid: 15,
        },
      };

      let listingData = await apiRequest(
        `${url}OrderPanelApi/ledger`,
        apiSetting
      );

      if (listingData.data && listingData.data.success == 1) {
        // Fixed comparison

        setLedgerList(listingData.data.data.data);
        setFilterData(listingData.data.data.data);
        setSummaryData(listingData?.data?.data?.summar_data);
        setHeaderInfo(listingData?.data?.data?.heading_info);
      } else {
        throw new Error(listingData.data.message);
      }
    } catch (error) {
      ReactToast({ type: "error", message: error.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="d-flex w-100 flex-column flex-md-row justify-content-between align-items-center">
        <div className="text-center text-md-start">
          <h5>Ledger</h5>
          <small>{headerInfo?.name}</small>
        </div>
        {headerInfo && (
          <div className="text-center text-md-end">
            <small>{headerInfo?.start_date}</small> -{" "}
            <small>{headerInfo?.end_date}</small>
          </div>
        )}
      </div>

      <SearchBar onSearch={onSearch} />
      <BasicTable
        headers={headerData}
        data={filterData}
        footerContent={
          summaryData &&
          summaryData?.length > 0 &&
          summaryData?.map((item, index) => (
            <tr key={index}>
              
              <td align="right" className="closing_remarks">
                <strong>{item?.remarks}</strong>
              </td>
              <td index={5} id="grandTotal" align="right">
                <strong className={index === 0 ? "text-danger" : ""}>
                  {item?.debit || "0.00"}
                </strong>
              </td>
              <td index={5} id="grandTotal" align="right">
                <strong className={index === 0 ? "text-success" : ""}>
                  {item?.credit || "0.00"}
                </strong>
              </td>
              
            </tr>
          ))
        }
        other_params ={{ class: "ledger_report" }}
      />
    </Fragment>
  );
}

export default LedgerListing;
